export default __webpack_public_path__ + "static/media/figo-logo.88d54c8f.svg";